import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex lg:flex-wrap lg:flex-row flex-col lg:items-center min-h-screen lg:justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "w-full px-4 lg:w-1/2 sm:px-20 lg:py-0 py-6"
}
const _hoisted_3 = { class: "sm:max-w-[360px] mx-auto" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/login",
    class: "m-0 text-sm transition text-primary-600 hover:text-primary-800"
  }, "Return to Login")
], -1)

import { ref, onMounted, inject } from 'vue';
import {
    IonPage,
    IonContent 
} from '@ionic/vue';

import Otp from '@/components/forms/Otp.vue';

import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';
import GeneralModal from '@/components/modals/GeneralModal.vue';

import Verification from '@/classes/Auth/Verification';

import { errorResponse } from "@/helpers/errorMessage";

import { useRoute, useRouter } from 'vue-router';

import AuthLogo from "../Components/AuthLogo.vue";
import AuthTitle from "../Components/AuthTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const showSuccess = ref<boolean>(false);
const showAccountVerified = ref<boolean>(false);
const showForm = ref<boolean>(true);
const errors = ref<any>([]);

const step = ref<number>(1);

const form = ref<{
    password: string|null,
    password_confirmation: string|null,
    pin_code: string|null,
    email: string,
    token: string,
}>({
    password: null,
    password_confirmation: null,
    pin_code: null,
    email: '', 
    token: '', 
})

const submit = (): void => {
    Verification.verify(form.value)
        .then(({ data }) => {
            showSuccess.value = true;
        })
        .catch((error: any) => {
            if (error.response?.status == 400) {
                showAccountVerified.value = true
                showForm.value = false
            } else {
                (errors.value = errorResponse(error.response?.data?.errors || error.response?.data?.error))
            }
        });

}

const init = (): void => {
    if (typeof route.query.email == 'undefined' && typeof route.query.token == 'undefined' ) {
        router.replace('login')
    } else {
        console.log(route.query.email);
        form.value.email = (route.query.email)?.toString()
        form.value.token = (route.query.token)?.toString()

        // @TODO I dont know what is this for??
        // Verification.isVerified(form.value).catch(() => {
        //     showAccountVerified.value = true
        //     showForm.value = false
        // });
    }
}

onMounted(() => {
    init();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AuthLogo),
            (showForm.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(AuthTitle, {
                      title: "New Password",
                      description: "Kindly provide your new password"
                    }),
                    _createElementVNode("form", {
                      class: "",
                      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.checkPassword && _ctx.checkPassword(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(PasswordInput, {
                          label: "New Password",
                          placeholder: "New Password",
                          name: "new-password",
                          id: "new-password",
                          modelValue: form.value.password,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.password) = $event)),
                          error: errors.value?.password
                        }, null, 8, ["modelValue", "error"])
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(PasswordInput, {
                          label: "Confirm Password",
                          placeholder: "Confirm Password",
                          name: "confirm-password",
                          id: "confirm-password",
                          modelValue: form.value.password_confirmation,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password_confirmation) = $event)),
                          error: errors.value?.password_confirmation
                        }, null, 8, ["modelValue", "error"])
                      ]),
                      _createVNode(ButtonComponent, {
                        type: "button",
                        size: "large",
                        btnWidth: "w-full rounded-lg",
                        onClick: submit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Set New Password ")
                        ]),
                        _: 1
                      }),
                      _hoisted_6
                    ], 32)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(SuccessModal, {
            show: showSuccess.value,
            onConfirm: _cache[3] || (_cache[3] = ($event: any) => {_unref(router).replace('login'); showSuccess.value = false}),
            "action-text": "Confirm",
            title: "Verification Completed!",
            content: "You have successfully set up your account."
          }, null, 8, ["show"]),
          _createVNode(GeneralModal, {
            show: showAccountVerified.value,
            onConfirm: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).replace('login'))),
            "action-text": "Go to Login",
            title: "Error!",
            content: "This account is aleardy verified. Please proceed to login"
          }, null, 8, ["show"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})